import { SafeHtml } from '@angular/platform-browser';

export class Alert {
    id?: string;
    uniqueId?: string;
    type?: AlertType;
    message?: SafeHtml;
    autoClose?: boolean;
    keepAfterRouteChange?: boolean;
    fade?: boolean;
    closeable?: boolean;
    lastUpdatedDate: Date;

    constructor(init?:Partial<Alert>) {
        Object.assign(this, init);
    }
}

export enum AlertType {
    Info = 'INFO',
    Warning = 'WARNING',
    Error = 'ERROR',
    Success = 'SUCCESS'
}

export class AlertOptions {
    uniqueId?: string;
    autoClose?: boolean;
    keepAfterRouteChange?: boolean;
    hasCloseButton?: boolean;
}
